import styled from "styled-components";
import { ImageWrapper as _ImageWrapper } from "@/lib/styles/theme";

export const InlineImage = styled.span<{ $hasLoaded: boolean }>`
  & > span {
    vertical-align: middle;
  }
`;

export const ContainerImage = styled(_ImageWrapper)<{ $hasLoaded: boolean }>`
  width: 100%;
  padding-bottom: 50%;
`;
